<template>
  <div class="task-level" v-if="visible">
    <div class="task-content">
      <div class="left-btn" v-if="imgList.length > 1">
        <i @click.stop="next(-1)" title="上一张" class="el-icon-arrow-left" />
      </div>
      <div class="img-box">
        <img :src="imgList[idx]" />
      </div>
      <div class="right-btn" v-if="imgList.length > 1">
        <i @click.stop="next(1)" title="下一张" class="el-icon-arrow-right" />
      </div>
    </div>

    <div @click="close" class="task-close-btn">
      <i title="关闭" class="el-icon-close" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ImgPreview",
  data() {
    return {
      idx: 0,
      visible: false,
      imgList: [],
    };
  },
  methods: {
    Open() {
      console.log(this.imgList, this.idx)
      this.visible = true;
    },
    close() {
      this.visible = false;
      this.imgList = [];
      this.idx = 0;
    },
    next(i) {
      const idx = this.idx + i;
      if (idx >= this.imgList.length) {
        this.idx = 0;
      } else if (idx < 0) {
        this.idx = this.imgList.length - 1;
      } else {
        this.idx = idx;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.task-level {
  z-index: 20000;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: scroll;
  box-sizing: border-box;

  .task-content {
    width: 80vw;
    transition: all 0.2s linear;
    display: flex;
    justify-content: center;

    .left-btn {
      position: fixed;
      height: 100%;
      width: 100px;
      top: 0;
      left: 10vw;
      z-index: 200;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .right-btn {
      position: fixed;
      height: 100%;
      width: 100px;
      top: 0;
      right: 10vw;
      z-index: 200;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    i {
      font-size: 64px;
      color: #fff;
      background: rgba(255, 255, 255, 0.25);
      border-radius: 50%;
      transition: all 0.2s linear;
      opacity: 0.6;

      &:hover {
        opacity: 1;
      }
    }
    .img-box {
      min-width: 200px;
      max-width: 80vw;
      min-height: 200px;
      max-height: 90vh;
      overflow: auto;
      padding: 20px;
      background-color: #fff;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        z-index: 100;
        height: auto;
        width: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }
  }

  .task-close-btn {
    position: fixed;
    right: 0;
    top: 0;
    height: 48px;
    width: 48px;
    background: #fff;
    border-bottom-left-radius: 60%;
    display: flex;
    justify-content: center;
    align-items: center;

    i {
      color: #000;
      font-size: 40px;
      transition: all 0.2s linear;

      &:hover {
        color: #dc3545;
      }
    }
  }
}
</style>
